import { Chip } from '@mui/material';

export const StatusChip = ({ params }) => (
  <Chip
    label={params.row.status}
    sx={{ color: params?.row.color_status, borderColor: params?.row.color_status }}
    variant="outlined"
  />
);
